import { useState, useEffect, useCallback, useRef } from 'react';
import { useGetNotificationsMutation, usePutNotificationsAsReadMutation } from "services/notification/notification.endpoint";
import { Notification } from 'services/notification/notification.types';

export const useNotificationListVM = (setUnreadCount: (count: number) => void) => {
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [offset, setOffset] = useState(0);
    const [isReadAll, setIsReadAll] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const LIMIT = 10;
    
    const [getNotifications, { isLoading, isUninitialized }] = useGetNotificationsMutation();
    const [putNotificationsAsRead] = usePutNotificationsAsReadMutation();

    const fetchNotifications = async () => {
        try {
            const response = await getNotifications({ limit: LIMIT, offset }).unwrap();
            if (response.data) {
                if (offset === 0) {
                    setNotifications(response.data);
                } else {
                    setNotifications(prev => [...prev, ...response.data]);
                }
                setHasMore(response.data.length === LIMIT);
            }

        } catch (error) {
            console.error('Erreur lors du chargement des notifications:', error);
        }

        if(!isReadAll) {
            await putNotificationsAsRead(undefined).unwrap();
            setUnreadCount(0);
            setIsReadAll(true);
        }
    };

    useEffect(() => {
        fetchNotifications();
    }, [offset]);

    const handleScroll = useCallback((event: React.UIEvent<HTMLDivElement>) => {
        const target = event.target as HTMLDivElement;
        if (isLoading || !hasMore) return;

        if (target.scrollHeight - target.scrollTop <= target.clientHeight + 50) {
            setOffset(prev => prev + LIMIT);
        }
    }, [isLoading, hasMore]);

    return {
        notifications,
        isLoading,
        isUninitialized,
        handleScroll
    };
};